export const REASONS = {
  TRAILER_WITH_LIFTGATE: 'TRAILER_WITH_LIFTGATE',
  NON_CORE_SALES_AREA: 'NON_CORE_SALES_AREA',
  LH_EXPRESS: 'LH_EXPRESS',
};
